import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Typography from '../Typography/Typography';
import { styled } from '@mui/material/styles';
import { baseSelectButtonClasses } from './baseSelectButtonClasses';

const propsForStylingOnly = [
  'isError',
  'hasValues',
  'readOnly',
  'isClearable',
  'size'
];

const BUTTON_SIZES = {
  small: 120,
  medium: 280,
  large: 360,
  fullWidth: '100%'
};

/** TODO: Update those colors once they are included in the palette */
const navigationColor = '#7A6E95';
const navigationHoverColor = '#4A396E';

export const BaseSelectButtonRoot = styled('span', {
  name: 'AFBaseSelectButton'
})('');

export const LabelContainer = styled(FormLabel, {
  shouldForwardProp: prop => prop !== 'hasTooltip'
})(({ theme, hasTooltip }) => ({
  display: 'flex',
  alignItems: 'center',
  [`& .${baseSelectButtonClasses.label}`]: {
    paddingLeft: theme.spacing(0.5),
    marginRight: hasTooltip ? theme.spacing(0.5) : null,
    color: theme.palette.text.primary
  },
  [`& .${baseSelectButtonClasses.helpIcon}`]: {
    color: navigationColor,
    '&:hover': {
      color: navigationHoverColor
    }
  }
}));

export const SelectButtonContainer = styled(Grid, {
  shouldForwardProp: prop => !propsForStylingOnly.includes(prop)
})(({ theme, 'data-readonly': dataReadOnly, ...props }) => ({
  border: props.isError
    ? `1px solid ${theme.palette.error.main}`
    : `1px solid ${theme.palette.divider}`,
  color: props.hasValues ? theme.palette.text.primary : theme.palette.text.hint,
  transition: 'none',
  width: BUTTON_SIZES[props.size],
  height: 36,
  borderRadius: `${theme.shape.borderRadius}px`,
  backgroundColor: props.readOnly
    ? theme.palette.background.default
    : theme.palette.common.white,
  padding: theme.spacing(0, 1),
  '&:disabled': {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.text.disabled
  },
  '&:hover': {
    ...(!dataReadOnly &&
      !props.disabled && {
        cursor: 'pointer',
        borderColor: theme.palette.grey[800],
        [`& .${baseSelectButtonClasses.expandIcon}`]: {
          color: theme.palette.grey[800]
        }
      })
  },
  '&:focus-visible': {
    outlineColor: props.isError
      ? theme.palette.error.main
      : theme.palette.primary.main
  }
}));

export const FooterContainer = styled(Grid, {
  shouldForwardProp: prop => prop !== 'size'
})(({ theme, size }) => ({
  display: 'flex',
  width: BUTTON_SIZES[size],
  marginTop: theme.spacing(0.5),
  paddingLeft: theme.spacing(0.5)
}));

export const ErrorLabelContainer = styled('div')({
  display: 'flex'
});

export const ErrorMessage = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(0.75)
}));

export const IconsContainer = styled(Grid, {
  shouldForwardProp: prop => prop !== 'isClearable' && prop !== 'disabled'
})(({ theme, isClearable, disabled }) => ({
  marginLeft: theme.spacing(0.5),
  maxWidth: isClearable ? '40px' : '20px',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  [`& .${baseSelectButtonClasses.clearIcon}`]: {
    marginRight: theme.spacing(0.5),
    ...(!disabled && {
      '&:hover': {
        color: theme.palette.grey[800]
      }
    })
  }
}));

export const HelperMessage = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.text.secondary
}));
